export default __webpack_public_path__ + "static/media/C2QB_green_btn_lg_default.3dc49ab2.png";